var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"mx-2 my-1",attrs:{"fab":"","small":""},on:{"click":_vm.onPickFile}},[_c('v-icon',[_vm._v("mdi-folder-open-outline")])],1),_c('input',{ref:"fileInput",staticClass:"d-none",attrs:{"type":"file","accept":_vm.langs},on:{"change":_vm.loadTextFromFile}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }